<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Solicitacao"
    >
        <Form
            @save="handleSave"
            class="form"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {
            this.$refs.Modal.show()
        },
        handleSave(data) {

            this.$emit('save', data)
            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        },
    },
}
</script>